import Card from '@mui/material/Card'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import {useEffect, useState} from 'react'
import { makeStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import CardAppointment from '../../components/CardAppointment/CardAppointment'
import allActions from "../../redux/actions/user";
import {useDispatch, useSelector} from "react-redux";
import Skeleton from "@material-ui/lab/Skeleton";

const useStyles = makeStyles({
  root: {
    height: 'calc(100vh - 80px - 40px - 20px - 32px) !important',
    backgroundColor: '#F3F3F3 !important',
    placeSelf: 'center',
    margin: '20px auto 0 auto',
    maxWidth: 600,
    overflowY: 'auto',
    padding: 16,
  },
  tabs: {
    borderBottom: '1px solid #e0e0e0',
    marginBottom: 16,
  },
  tabCard: {
    maxHeight: 'calc(100vh - 80px - 40px - 20px - 32px - 70px) !important',
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    alignItems: 'center',
    overflowY: 'auto',
    overflowX: 'hidden',
  }
})

export default function MyAppointment() {
  const user = useSelector(state => state.user);
  const dispatch = useDispatch()

  const classes = useStyles()
  const [value, setValue] = useState(0)
  const [allCreneau, setAllCreneau] = useState([])
  const [loading, setLoading] = useState(false)

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  function createSkeleton() {
    return (
      <>
        <Skeleton variant="rectangular" height={200} width={'100%'} />
        <Skeleton variant="rectangular" height={200} width={'100%'} />
        <Skeleton variant="rectangular" height={200} width={'100%'} />
        <Skeleton variant="rectangular" height={200} width={'100%'} />
        <Skeleton variant="rectangular" height={200} width={'100%'} />
      </>
    )
  }

  useEffect(() => {
    if (user?.id){
      if (value === 0){
        const fetchDataCreneau = async () => {
          try {
            setLoading(true)
            dispatch(allActions.setLoading(true))
            const result = await allActions.fetchGetAPI(`api/planning/creneau-reserved/${user.id}`)
            setAllCreneau(result.json)
            setLoading(false)
            dispatch(allActions.setLoading(false))
          } catch (err) {
            console.log(err)
          }
        }
        fetchDataCreneau()
      }
      if (value === 1){
        const fetchDataCreneau = async () => {
          try {
            setLoading(true)
            dispatch(allActions.setLoading(true))
            const result = await allActions.fetchGetAPI(`api/planning/creneau-historique/${user.id}`)
            setAllCreneau(result.json)
            setLoading(false)
            dispatch(allActions.setLoading(false))
          } catch (err) {
            console.log(err)
          }
        }
        fetchDataCreneau()
      }
    }
  }, [user, value])

  return (
    <Card className={classes.root}>
      <Tabs
        className={classes.tabs}
        value={value}
        indicatorColor="primary"
        textColor="primary"
        centered
        onChange={handleChange}
      >
        <Tab label="Mes rendez-vous" />
        <Tab label="Historique" />
      </Tabs>
      <TabPanel value={value} index={0} className={classes.tabCard}>
        {loading ?
          createSkeleton() :
          allCreneau?.length > 0 ?
            (allCreneau?.map((appointment, index) => <CardAppointment key={index} appointment={{ id: appointment.id, title: 'Rendez-vous : Inscription', date: appointment.date, location: appointment.location, activites: appointment.activities }} />)) :
            <Typography variant="h6" component="h2" style={{ textAlign: 'center', marginTop: 16 }}>
              Aucun rendez-vous
            </Typography>
        }
      </TabPanel>
      <TabPanel value={value} index={1} className={classes.tabCard}>
        {loading ?
          createSkeleton() :
          allCreneau?.length > 0 ?
            (allCreneau?.map((appointment, index) =>
              <CardAppointment key={index} appointment={{ id: appointment.id, title: 'Rendez-vous : Inscription', date: appointment.date, location: appointment.location, activites: appointment.activities, isHistory: true }} />)) :
            <Typography variant="h6" component="h2" style={{ textAlign: 'center', marginTop: 16 }}>
              Aucun rendez-vous
            </Typography>
        }
      </TabPanel>
    </Card>
  )
}

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  )
}

TabPanel.propTypes = {
  children: PropTypes.any,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
}

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  }
}
